import { MutationTree } from 'vuex';
import { Event, EventsState } from './models';
import { EventForWidget } from '../components/EventsWidget/models';

export enum Mutations {
  GET_EVENTS_REQUEST = 'GET_EVENTS_REQUEST',
  GET_EVENTS_SUCCESS = 'GET_EVENTS_SUCCESS',
  GET_EVENTS_FAILURE = 'GET_EVENTS_FAILURE',
  GET_EVENTS_WIDGET_REQUEST = 'GET_EVENTS_WIDGET_REQUEST',
  GET_EVENTS_WIDGET_SUCCESS = 'GET_EVENTS_WIDGET_SUCCESS',
  GET_EVENTS_WIDGET_FAILURE = 'GET_EVENTS_WIDGET_FAILURE',
  APPLY_EVENT_FOR_WIDGET = 'APPLY_EVENT_FOR_WIDGET',
}

export const mutations: MutationTree<EventsState> = {
  [Mutations.GET_EVENTS_REQUEST](state) {
    state.events = [];
  },
  [Mutations.GET_EVENTS_SUCCESS](state, payload: Event[]) {
    state.events = payload;
  },
  [Mutations.GET_EVENTS_FAILURE](state) {
    state.events = [];
  },

  [Mutations.GET_EVENTS_WIDGET_REQUEST](state) {
    state.eventsForWidget = [];
  },
  [Mutations.GET_EVENTS_WIDGET_SUCCESS](state, payload: EventForWidget[]) {
    state.eventsForWidget = payload;
  },
  [Mutations.GET_EVENTS_WIDGET_FAILURE](state) {
    state.eventsForWidget = [];
  },

  [Mutations.APPLY_EVENT_FOR_WIDGET](state, updatedEvent: EventForWidget) {
    const eventIndex = state.eventsForWidget.findIndex((e) => e.id === updatedEvent.id);
    state.eventsForWidget.splice(eventIndex, 1, updatedEvent);
  },
};
